import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Desktop = _resolveComponent("Desktop")!
  const _component_Mobile = _resolveComponent("Mobile")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({ 'nav--scrolled': _ctx.setNavColor })
  }, [
    _createVNode(_component_Desktop),
    _createVNode(_component_Mobile)
  ], 2))
}